import React, { useState, useEffect } from 'react';
import { Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { API_ADMIN } from '../../utils/urls';
import { getAuthorityUserInfo } from '../../utils/authority';
import { isEmptyObject } from '../../utils/reg';
import { decryptString } from '../../utils/encrypUtils';
import './index.less';
import { Modal } from '@/components';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
const UploadFile = (props) => {
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);

  const { max = 5, folderType = 12 } = props;

  useEffect(() => {
    if (props.url) {
      setFileList([{ uid: props.url, status: 'done', url: props.url }]);
    }
  }, [props.url]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };
  const handleChange = (data) => {
    let { fileList } = data;
    const file = fileList[0];
    if (!file) {
      setFileList([]);
      props.onChange && props.onChange(undefined);
      return;
    }

    const { response = {}, uid } = file;
    if (file.response) {
      if (response.code === 200) {
        try {
          const url = JSON.parse(decryptString(response.data));
          const imageUrl = url.length > 0 ? url[0] : '';
          setFileList([{ uid, status: 'done', url: imageUrl }]);
          props.onChange && props.onChange(imageUrl);
        } catch {
          message.error(response.msg || '上传失败');
          setFileList([]);
          props.onChange && props.onChange(undefined);
        }
      } else {
        message.error(response.msg || '上传失败');
        setFileList([]);
        props.onChange && props.onChange(undefined);
      }
      return;
    }

    if (file.status === 'error') {
      message.error('上传失败');
      setFileList([]);
      props.onChange && props.onChange(undefined);
      return;
    }

    setFileList(fileList);
  };

  const beforeUpload = (file) => {
    const checkSize = file.size / 1024 / 1024 < max;
    if (!checkSize) {
      message.error(`单个文件不能超过${max}M!`);
    }
    return checkSize;
  };
  let userinfo = getAuthorityUserInfo();
  let hash = !isEmptyObject(userinfo) ? userinfo.access_token : '';
  const uploadProps = () => {
    // const params = { fileList, fileType };
    const param = {
      action: `${API_ADMIN}file/v800/uploadFile/${folderType}`,
      listType: 'picture-card',
      showUploadList: { showPreviewIcon: true },
      accept: '.png,.jpg,.jpeg',
      fileList,
      onChange: handleChange,
      headers: {
        authorization: 'authorization-text',
        accessToken: hash,
        appType: 'admin',
      },
      onPreview: handlePreview,
    };
    if (max) {
      return {
        ...param,
        beforeUpload: beforeUpload,
      };
    }
    return param;
  };

  return (
    <>
      <Upload {...uploadProps({})} className='upload-file'>
        {fileList.length ? null : (
          <div className='upload-file-placeholder'>
            <PlusOutlined />
            <div className='upload-file-placeholder-text'>上传图片</div>
          </div>
        )}
      </Upload>

      <Modal open={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
        <img alt='example' style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
};

export default UploadFile;
